import { useState } from 'react';
import { FilterIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Popover, PopoverTrigger, PopoverContent } from '@/components/ui/popover';

import { useApplications } from '../model';

import FilterForm from './FilterForm';

const ApplicationsFilter = () => {
  const { activeFilterCount } = useApplications();
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" className="gap-2">
          <FilterIcon className="size-4" />
          Filter
          {Boolean(activeFilterCount) && (
            <Badge
              variant="pill"
              className="bg-accent-software-escrow border-0 text-2xs text-white h-4.5 min-4.5 px-1 min-w-4.5 justify-center font-bold"
            >
              {activeFilterCount}
            </Badge>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0">
        <FilterForm onDone={() => setOpen(false)} />
      </PopoverContent>
    </Popover>
  );
};

export default ApplicationsFilter;
